


































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Card from "@/store/entities/card";
import MediaBox from "@/components/media/media-box.vue";
import { EventBus } from "@/lib/eventbus";
import Editor from "@tinymce/tinymce-vue";
import MediaPicker from "@/components/media/media-picker.vue";
@Component({
  components: { MediaBox, editor: Editor, MediaPicker },
})
export default class EditCard extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  $refs!: {
    editor: any;
    form: any;
    tiny: any;
  };
  card: Card = new Card();
  spinShow: boolean = true;
  callbackVar = null;
  get mediaPickerShow() {
    return this.$store.state.mediapicker.show;
  }
  set mediaPickerShow(value) {
    this.$store.commit("mediapicker/setShow", value);
  }
  initConfig() {
    return {
      height: 700,
      menubar: false,
      plugins: [
        "advlist autolink lists link image imagetools charmap print preview anchor",
        "searchreplace visualblocks code fullscreen",
        "insertdatetime media table paste code help wordcount",
      ],
      toolbar:
        "undo redo | formatselect | bold italic forecolor backcolor | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | help | image",
      file_picker_callback: function (callback, value, meta) {
        this.$store.commit("mediapicker/setType", 0);
        this.$store.commit("mediapicker/setShow", true);
        this.callbackVar = callback;
      }.bind(this),
    };
  }
  save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        let card = this.card;
        //@ts-ignore
        this.card.content = tinymce.editors["editCardEditor"].getContent();
        this.spinShow = true;
        if (this.card.id > 0) {
          await this.$store
            .dispatch({
              type: "cards/update",
              data: this.card,
            })
            .then(() => {
              (this.$refs.form as any).resetFields();
              this.$router.push({ name: "cards" });
            });
        } else {
          await this.$store
            .dispatch({
              type: "cards/create",
              data: this.card,
            })
            .then(() => {
              (this.$refs.form as any).resetFields();
              this.$router.push({ name: "cards" });
            });
        }
      }
    });
  }
  cancel() {
    this.$router.push({ name: "cards" });
  }
  imageRecived(mediaitem) {
    this.card.imageUrl = mediaitem.fileWebPath;
    this.card.imageId = mediaitem.id;
  }
  mounted() {
    EventBus.$on("sendImageForBoxImage", (mediaitem) => {
      this.imageRecived(mediaitem);
    });
    EventBus.$on("sendImageForWyswig", (imgPath) => {
      this.callbackVar(imgPath);
    });
  }
  async getpage() {
    var cardId = this.$route.params.cardId;
    if (parseInt(cardId) > 0) {
      await this.$store
        .dispatch({
          type: "cards/get",
          data: { id: cardId },
        })
        .then((result) => {
          this.card = result;
          this.spinShow = false;
        });
    } else {
      this.spinShow = false;
    }
  }
  async created() {
    this.getpage();
  }
  get availableClasses() {
    return [
      {
        label: "Padding 0",
        value: "p-0",
      },
      {
        label: "Padding .25",
        value: "p-1",
      },
      {
        label: "Padding .5",
        value: "p-2",
      },
      {
        label: "Padding 1",
        value: "p-3",
      },
      {
        label: "Padding 1.5",
        value: "p-4",
      },
      {
        label: "Padding 3",
        value: "p-5",
      },
    ];
  }
  rules = {
    title: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Title")),
        trigger: "blur",
      },
    ],
  };
}
